<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer002">
<p class="OT" id="_idParaDest-2"><a id="_idTextAnchor001"></a><a href="#/Reid_Wisdoms_Feast3#toc1">Acknowledgments</a></p>
<p class="BODYFLUSH">It is with deep gratitude that I thank all those who have helped to shape my feminist consciousness and who have taught me ways of feminist biblical interpretation: my mother, Christine F. Reid, whose keen sense of equal dignity for all remains ever a part of me; my first teachers and now my companions in life and mission, the Dominican Sisters of Adrian and Grand Rapids, Michigan; my professors at the Catholic University of America, especially Elizabeth Johnson and Mary Ann Getty Sullivan; my colleagues, students, and staff at Catholic Theological Union, who continue to stretch and support me; and countless scholars and friends whose insights and wisdom constantly open new horizons for me.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Reid_Wisdoms_Feast4.vue?96da6968